<template>
  <div class="contentDetails">
    <NavBar :navBlock='navBlock' :navtitle='navtitle' :pageBack='true'></NavBar>
    <div class="detailsContent">
      <JJdiary :type='type' :id='id'></JJdiary>
    </div>
  </div>
</template>

<script>
import NavBar from '@/components/navBar'
import JJdiary from '@/components/JJdiary'
export default {
  data () {
    return {
      navBlock: '新聞  /  Wayne',
      navtitle: '新增',
      type: 'add',
      id: this.$route.query.id,
    }
  },
  components: {
    NavBar,
    JJdiary
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/news/JJdiary/addDiary.vue